import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Register from './components/Register'; // Import line add karein
import UserGuide from './components/UserGuide';
import AdminPanel from './components/AdminPanel';
import ForgetPassword from './components/ForgetPassword'; // Import line add karein

function App() {
    const [token, setToken] = useState(localStorage.getItem('token'));

    // Token change hone par state update karein
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        setToken(storedToken);
    }, []);

    return (
        <Router>
            <Routes>
                {/* Login Route */}
                <Route path="/login" element={!token ? <Login setToken={setToken} /> : <Navigate to="/dashboard" />} />
                
                {/* Dashboard Protected Route */}
                <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
                
                {/* Default redirect */}
                <Route path="*" element={<Navigate to={token ? "/dashboard" : "/login"} />} />

                
                {/* Register Route */}
                <Route path="/register" element={<Register />} />
                <Route path="/forget-password" element={<ForgetPassword />} />

                <Route path="/docs" element={<UserGuide />} />
                <Route path="/admin" element={token ? <AdminPanel /> : <Navigate to="/login" />} />
            </Routes>
        </Router>
    );
}

export default App;